import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const styles = {
  nav: {
    position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '0 48px', height: '64px',
    background: 'rgba(250,250,247,0.92)',
    backdropFilter: 'blur(12px)',
    borderBottom: '1px solid var(--border)',
  },
  brand: {
    fontFamily: 'var(--font-display)',
    fontSize: '1.05rem', fontWeight: 600,
    letterSpacing: '0.04em', textTransform: 'uppercase',
    color: 'var(--navy)',
  },
  links: {
    display: 'flex', gap: '32px', alignItems: 'center',
  },
  link: {
    fontSize: '0.82rem', fontWeight: 500,
    color: 'var(--muted)', letterSpacing: '0.03em',
    transition: 'color 0.15s',
  },
  linkActive: {
    color: 'var(--navy)',
  },
  cta: {
    fontSize: '0.82rem', fontWeight: 500,
    color: 'var(--white)', background: 'var(--navy)',
    padding: '9px 22px', borderRadius: '4px',
    letterSpacing: '0.03em',
    transition: 'background 0.2s',
    border: 'none', cursor: 'pointer',
  },
};

export default function Nav({ hasResults, onRetake }) {
  const { pathname } = useLocation();

  function linkStyle(path) {
    return pathname === path
      ? { ...styles.link, ...styles.linkActive }
      : styles.link;
  }

  return (
    <nav style={styles.nav}>
      <Link to="/" style={styles.brand}>Lifestyle Intelligence Hub</Link>
      <div style={styles.links}>
        {hasResults && (
          <>
            <Link to="/results" style={linkStyle('/results')}>My Protocol</Link>
            <Link to="/coach" style={linkStyle('/coach')}>Coach</Link>
          </>
        )}
        <Link to="/assessment" onClick={hasResults ? onRetake : undefined}>
          <button style={styles.cta}>
            {hasResults ? 'Retake Assessment' : 'Begin Assessment'}
          </button>
        </Link>
      </div>
    </nav>
  );
}
